import React from 'react'

import ActionButton from '@/components/misc/ActionButton'
import InviteUsers from '@/components/misc/InviteUsers'
import { Button } from '@/components/ui/button'
import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'

interface Props {
  onSuccess?: () => void
  onCancel?: () => void
  autoFocus?: boolean
}

const InviteUsersForm: React.FC<Props> = ({
  onSuccess,
  onCancel,
  autoFocus = false,
}) => {
  const currentCompany = useCurrentCompanyOrFail()

  return (
    <InviteUsers autoFocus={autoFocus} onSuccess={onSuccess}>
      {({ renderForm, isProcessing }) => (
        <>
          <div>
            <p className="mb-4 text-[16px]">
              Please enter the email addresses of the users you'd like to invite
              under your company{' '}
              <strong>{currentCompany.presentationName}</strong>.
            </p>

            {renderForm()}
          </div>

          <div className="flex items-center justify-end gap-2">
            {onCancel && (
              <Button
                variant="outline-secondary"
                size="lg"
                type="button"
                onClick={onCancel}
              >
                Cancel
              </Button>
            )}

            <ActionButton
              variant="primary"
              type="submit"
              isProcessing={isProcessing}
              isProcessingText="Sending invitation"
              disabled={isProcessing}
              size="lg"
            >
              Send invites
            </ActionButton>
          </div>
        </>
      )}
    </InviteUsers>
  )
}

export default InviteUsersForm
